import { Inject, Injectable, Injector } from '@angular/core';


import { PrintNode_execute_print_queueService } from './PrintNode.flow.index';
import { PrintNode_get_print_queue_gridService } from './PrintNode.flow.index';
import { PrintNode_get_printers_by_location_flowService } from './PrintNode.flow.index';
import { PrintNode_insert_into_print_queueService } from './PrintNode.flow.index';
import { PrintNode_print_request_flowService } from './PrintNode.flow.index';
import { PrintNode_set_device_associations_by_type_flowService } from './PrintNode.flow.index';
import { PrintNode_update_printQueue_tableService } from './PrintNode.flow.index';
import { PrintNode_validate_credentials_flowService } from './PrintNode.flow.index';

import { $frontendTypes } from './PrintNode.frontend.types'

@Injectable({ providedIn: 'root' })
export class PrintNode_FlowService {

  constructor(
    private injector: Injector
  ) {
  }

  public PrintNode: PrintNode_FlowService = this;

  // injecting lazily in order to avoid circular dependencies
 
  private _execute_print_queue: PrintNode_execute_print_queueService;
  public async execute_print_queue($inParams: {  }): Promise< { reasons?: string[] }> {
    if(!this._execute_print_queue) { 
      this._execute_print_queue = this.injector.get(PrintNode_execute_print_queueService);
    }
    return this._execute_print_queue.run($inParams);
  }
   
   

   
 
  private _get_print_queue_grid: PrintNode_get_print_queue_gridService;
  public async get_print_queue_grid($inParams: {  }): Promise< { list?: { printerId?: number, title?: string, contentType?: string, content?: string, batchNumber?: number, printSequence?: number, printed?: boolean, locked?: boolean, retry?: number, id?: string, source?: string, reference?: string }[] }> {
    if(!this._get_print_queue_grid) { 
      this._get_print_queue_grid = this.injector.get(PrintNode_get_print_queue_gridService);
    }
    return this._get_print_queue_grid.run($inParams);
  }
   
   

   
 
  private _get_printers_by_location_flow: PrintNode_get_printers_by_location_flowService;
  public async get_printers_by_location_flow($inParams: { location_id: number }): Promise< { reasons?: string[], printers?: { letter_printer: { id: number, name: string }, label_printer: { id: number, name: string } } }> {
    if(!this._get_printers_by_location_flow) { 
      this._get_printers_by_location_flow = this.injector.get(PrintNode_get_printers_by_location_flowService);
    }
    return this._get_printers_by_location_flow.run($inParams);
  }
   
   

   
 
  private _insert_into_print_queue: PrintNode_insert_into_print_queueService;
  public async insert_into_print_queue($inParams: { printerId?: number, title?: string, contentType?: string, content?: string, source?: string, batchNumber?: number, printSequence?: number, transactionId?: string, reference?: string }): Promise< { reasons?: string[] }> {
    if(!this._insert_into_print_queue) { 
      this._insert_into_print_queue = this.injector.get(PrintNode_insert_into_print_queueService);
    }
    return this._insert_into_print_queue.run($inParams);
  }
   
   

   
 
  private _print_request_flow: PrintNode_print_request_flowService;
  public async print_request_flow($inParams: { printerId: number, content: string, contentType?: string, transactionId?: string, queuePrintJobs?: boolean, batchNumber?: number, printSequence?: number, reference?: string }): Promise< { outputDetails?: string, printJobId?: number }> {
    if(!this._print_request_flow) { 
      this._print_request_flow = this.injector.get(PrintNode_print_request_flowService);
    }
    return this._print_request_flow.run($inParams);
  }
   
   

   
 
  private _set_device_associations_by_type_flow: PrintNode_set_device_associations_by_type_flowService;
  public async set_device_associations_by_type_flow($inParams: { entity_type: $frontendTypes.PrintNode.e_entity_type, entity_id: string, device_ids: string[], device_type: $frontendTypes.PrintNode.e_device_type }): Promise< { reasons?: string[] }> {
    if(!this._set_device_associations_by_type_flow) { 
      this._set_device_associations_by_type_flow = this.injector.get(PrintNode_set_device_associations_by_type_flowService);
    }
    return this._set_device_associations_by_type_flow.run($inParams);
  }
   
   

   
 
  private _update_printQueue_table: PrintNode_update_printQueue_tableService;
  public async update_printQueue_table($inParams: { printJobId?: string, locked?: boolean, retry?: number, transactionId?: string }): Promise< { reasons?: string[] }> {
    if(!this._update_printQueue_table) { 
      this._update_printQueue_table = this.injector.get(PrintNode_update_printQueue_tableService);
    }
    return this._update_printQueue_table.run($inParams);
  }
   
   

   
 
  private _validate_credentials_flow: PrintNode_validate_credentials_flowService;
  public async validate_credentials_flow($inParams: {  }): Promise< { validation?: string, outputDetails?: string }> {
    if(!this._validate_credentials_flow) { 
      this._validate_credentials_flow = this.injector.get(PrintNode_validate_credentials_flowService);
    }
    return this._validate_credentials_flow.run($inParams);
  }
   
   

   
}
